import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from '@/components/ui/badge';

const TAG_VARIANTS = {
  important: 'default',
  work: 'secondary',
};

const getTagVariant = (tag) => TAG_VARIANTS[tag] || 'outline';

const Tags = ({ tags }) => (
  <div className="flex flex-wrap gap-1">
    {tags.map((tag) => (
      <Badge key={tag} variant={getTagVariant(tag)}>
        {tag}
      </Badge>
    ))}
  </div>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Tags;
